/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Download_Stock_Out_NoteInputs */

const vi_invoice_download_stock_out_note = /** @type {(inputs: Invoice_Download_Stock_Out_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất kho`)
};

/**

* @param {Invoice_Download_Stock_Out_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_download_stock_out_note = /** @type {((inputs?: Invoice_Download_Stock_Out_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Download_Stock_Out_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_download_stock_out_note(inputs)
});